import { useState } from 'react';
import { FiLock, FiAlertCircle } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext.jsx';
import { api } from '../lib/apiClient.js';

// Forced first-login password reset for agency employees (PRD §8.2). Blocks the whole
// dashboard until the agent sets their own password, replacing the Authority's temp one.
export default function EmployeePasswordGate() {
  const { reloadProfile } = useAuth();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError('Passwords do not match.');
    setBusy(true);
    setError('');
    try {
      await api.employeeSetPassword(form.password);
      await reloadProfile(); // clears mustResetPassword via refreshed agency context
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 grid h-12 w-12 place-items-center rounded-2xl bg-slate-900 text-white">
            <FiLock className="h-6 w-6" />
          </div>
          <h1 className="text-xl font-bold text-slate-900">Set your password</h1>
          <p className="mt-1 text-sm text-slate-500">Choose a new password to replace the temporary one you were given.</p>
        </div>
        {error && (
          <div className="mb-5 flex items-start gap-2 rounded-lg border border-red-100 bg-red-50 p-3 text-sm text-red-600">
            <FiAlertCircle className="mt-0.5 h-4 w-4 shrink-0" /> {error}
          </div>
        )}
        <form onSubmit={submit} className="grid gap-4">
          <input
            type="password" value={form.password} required minLength={8} autoComplete="new-password"
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            placeholder="New password (min 8 characters)"
            className="w-full rounded-lg border border-slate-400 bg-slate-50/50 px-4 py-3 text-sm font-medium text-slate-900 outline-none focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-500/10"
          />
          <input
            type="password" value={form.confirm} required minLength={8} autoComplete="new-password"
            onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))}
            placeholder="Confirm new password"
            className="w-full rounded-lg border border-slate-400 bg-slate-50/50 px-4 py-3 text-sm font-medium text-slate-900 outline-none focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-500/10"
          />
          <button type="submit" disabled={busy} className="mt-2 w-full rounded-lg bg-black px-4 py-3.5 text-sm font-semibold text-white hover:bg-slate-900 disabled:opacity-50">
            {busy ? 'Saving…' : 'Save & continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
